module.exports = __webpack_public_path__ + "media/Image_Upscale.f035cfa3.webm";